// Date 2020-11-20 16:17:08

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";

import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

import emSppInventoryChangeIchList from "@/views/em/spareparts/EmSppInventoryChangeIchList.vue";
import emSppInventoryChangeIchEdit from "@/views/em/spareparts/EmSppInventoryChangeIchEdit.vue";
import emSppStorageInfoStiList from "@/views/em/spareparts/EmSppStorageInfoStiList.vue";
import emSppStorageInfoStiMove from "@/views/em/spareparts/EmSppStorageInfoStiMove.vue";
import emSppStorageInfoStiEdit from "@/views/em/spareparts/EmSppStorageInfoStiEdit.vue";
import emSppRequisitionSprTask from "@/views/em/spareparts/EmSppRequisitionSprTask.vue";
import emSppRequisitionSprEdit from "@/views/em/spareparts/EmSppRequisitionSprEdit.vue";
import emSppRequisitionSprList from "@/views/em/spareparts/EmSppRequisitionSprList.vue";
import emSppRequisitionDetSrdEdit from "@/views/em/spareparts/EmSppRequisitionDetSrdEdit.vue";
import emSppRequisitionDetSrdList from "@/views/em/spareparts/EmSppRequisitionDetSrdList.vue";
import emSppWarehousingSpwEdit from "@/views/em/spareparts/EmSppWarehousingSpwEdit.vue";
import emSppWarehousingSpwList from "@/views/em/spareparts/EmSppWarehousingSpwList.vue";
import emSppWarehousingDetSwdEdit from "@/views/em/spareparts/EmSppWarehousingDetSwdEdit.vue";
import emSppWarehousingDetSwdList from "@/views/em/spareparts/EmSppWarehousingDetSwdList.vue";
import emSppStorageLocList from "@/views/em/spareparts/EmSppStorageLocList";
import emSppStorageLocEdit from "@/views/em/spareparts/EmSppStorageLocEdit";
import emSppStorageSstList from "@/views/em/spareparts/EmSppStorageSstList";
import emSppStorageSstEdit from "@/views/em/spareparts/EmSppStorageSstEdit";
import emSppSparePartsCatSpcList from "@/views/em/spareparts/EmSppSparePartsCatSpcList";
import emSppSparePartsCatSpcEdit from "@/views/em/spareparts/EmSppSparePartsCatSpcEdit";
import emSparePartsInventorySpiEdit from "@/views/em/spareparts/EmSparePartsInventorySpiEdit.vue";
import emSparePartsInventorySpiList from "@/views/em/spareparts/EmSparePartsInventorySpiList.vue";
import emSparePartsInventoryCheckSicList from "@/views/em/spareparts/EmSparePartsInventoryCheckSicList.vue";
import emSparePartsInventoryCheckSicEdit from "@/views/em/spareparts/EmSparePartsInventoryCheckSicEdit.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/em/spareparts/emSppSource/list",
        name: "emSppSourceList",
        component: emLevelTreeListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppSource/edit",
        name: "emSppSourceEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppAttribute/list",
        name: "emSppAttributeList",
        component: emLevelTreeListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppAttribute/edit",
        name: "emSppAttributeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    // {
    // path: "/em/spareparts/emSppSparePartsCatSpc/list",
    // name: "emSppSparePartsCatSpcList",
    // component: emLevelTreeListView,
    //     props: (route) => ({ prop_inline: route.query.inline }),
    // meta: metaObject
    // },
    // {
    // path: "/em/spareparts/emSppSparePartsCatSpc/edit",
    // name: "emSppSparePartsCatSpcEdit",
    // component: emEntityEditView,
    // meta: metaObject
    // },
    {
        path: "/em/spareparts/emSppSparePartsSpa/list",
        name: "emSppSparePartsSpaList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_export: route.query.export,
            prop_import: route.query.import
        }),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppSparePartsSpa/edit",
        name: "emSppSparePartsSpaEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppStorageCatSsc/list",
        name: "emSppStorageCatSscList",
        component: emLevelTreeListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppStorageCatSsc/edit",
        name: "emSppStorageCatSscEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppStorageSstList",
        name: "emSppStorageSstList",
        component: emSppStorageSstList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppStorageSstEdit",
        name: "emSppStorageSstEdit",
        component: emSppStorageSstEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppStorageLocList",
        name: "emSppStorageLocList",
        component: emSppStorageLocList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppStorageLocEdit",
        name: "emSppStorageLocEdit",
        component: emSppStorageLocEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppLocation/list",
        name: "emSppLocationList",
        component: emLevelTreeListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppLocation/edit",
        name: "emSppLocationEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppWarehouseMgr/list",
        name: "emSppWarehouseMgrList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppWarehouseMgr/edit",
        name: "emSppWarehouseMgrEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppPurchaseStatePus/list",
        name: "emSppPurchaseStatePusList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppPurchaseStatePus/edit",
        name: "emSppPurchaseStatePusEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppInvChangeTypeIct/list",
        name: "emSppInvChangeTypeIctList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppInvChangeTypeIct/edit",
        name: "emSppInvChangeTypeIctEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppUnitSpu/list",
        name: "emSppUnitSpuList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppUnitSpu/edit",
        name: "emSppUnitSpuEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppRequisitionRwoSrr/list",
        name: "emSppRequisitionRwoSrrList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppRequisitionRwoSrr/edit",
        name: "emSppRequisitionRwoSrrEdit",
        component: emEntityEditView,
        meta: metaObject
    },

//自定义页面注册
    {
        path: "/em/spareparts/emSppInventoryChangeIchList",
        name: "emSppInventoryChangeIchList",
        component: emSppInventoryChangeIchList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppInventoryChangeIchEdit",
        name: "emSppInventoryChangeIchEdit",
        component: emSppInventoryChangeIchEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppStorageInfoStiList",
        name: "emSppStorageInfoStiList",
        component: emSppStorageInfoStiList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppStorageInfoStiMove",
        name: "emSppStorageInfoStiMove",
        component: emSppStorageInfoStiMove,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppStorageInfoStiEdit",
        name: "emSppStorageInfoStiEdit",
        component: emSppStorageInfoStiEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppRequisitionSprTask",
        name: "emSppRequisitionSprTask",
        component: emSppRequisitionSprTask,
        // component: emWorkflowTaskView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppRequisitionSprEdit",
        name: "emSppRequisitionSprEdit",
        component: emSppRequisitionSprEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppRequisitionSprList",
        name: "emSppRequisitionSprList",
        component: emSppRequisitionSprList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppRequisitionDetSrdEdit",
        name: "emSppRequisitionDetSrdEdit",
        component: emSppRequisitionDetSrdEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppRequisitionDetSrdList",
        name: "emSppRequisitionDetSrdList",
        component: emSppRequisitionDetSrdList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppWarehousingSpwEdit",
        name: "emSppWarehousingSpwEdit",
        component: emSppWarehousingSpwEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppWarehousingSpwList",
        name: "emSppWarehousingSpwList",
        component: emSppWarehousingSpwList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppWarehousingDetSwdEdit",
        name: "emSppWarehousingDetSwdEdit",
        component: emSppWarehousingDetSwdEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppWarehousingDetSwdList",
        name: "emSppWarehousingDetSwdList",
        component: emSppWarehousingDetSwdList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppSparePartsCatSpcList",
        name: "emSppSparePartsCatSpcList",
        component: emSppSparePartsCatSpcList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSppSparePartsCatSpcEdit",
        name: "emSppSparePartsCatSpcEdit",
        component: emSppSparePartsCatSpcEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSparePartsInventorySpiEdit",
        name: "emSparePartsInventorySpiEdit",
        component: emSparePartsInventorySpiEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSparePartsInventorySpiList",
        name: "emSparePartsInventorySpiList",
        component: emSparePartsInventorySpiList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSparePartsInventoryCheckSicList",
        name: "emSparePartsInventoryCheckSicList",
        component: emSparePartsInventoryCheckSicList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/spareparts/emSparePartsInventoryCheckSicEdit",
        name: "emSparePartsInventoryCheckSicEdit",
        component: emSparePartsInventoryCheckSicEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    }
]
